import { render, staticRenderFns } from "./DrawerCustomList.vue?vue&type=template&id=13d2b16c&scoped=true&"
import script from "./DrawerCustomList.vue?vue&type=script&lang=js&"
export * from "./DrawerCustomList.vue?vue&type=script&lang=js&"
import style0 from "./DrawerCustomList.vue?vue&type=style&index=0&id=13d2b16c&prod&lang=css&"
import style1 from "./DrawerCustomList.vue?vue&type=style&index=1&id=13d2b16c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d2b16c",
  null
  
)

export default component.exports